export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const gaId = (config.public.googleAnalyticsId as string) || 'G-7CH51VQQVE';

  if (!gaId) return;

  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gaId}`,
        async: true,
      },
      {
        innerHTML: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `,
      },
    ],
  });

  // Track page views on route change
  useRouter().afterEach((to) => {
    if (window.gtag) {
      window.gtag('config', gaId, { page_path: to.fullPath });
    }
  });
});

